<template>
    <button class="button-box" :class="className">
        <span><slot /></span>
    </button>
</template>

<script setup>
    import {computed} from "vue";

    const props = defineProps(["type"])

    const className = computed(() => {
        let str = "sure-box"

        if (null != props.type){
            switch (props.type) {
                case "success":
                    str = "sure-box"
                    break

                case "danger":
                    str = "refuse-box"
                    break
            }
        }

        return str
    })

</script>

<style scoped>
    .button-box {
        padding: 5px 25px;
        border-radius: 5px;
        display: inline-block;
        font-size: 18px;
        font-weight: 600;
        cursor: pointer;
    }

    .button-box.sure-box{
        border: 1px #d6e9c6 solid;
        background: #d6e9c6;
        color: #3c763d;
    }

    .button-box.sure-box:hover{
        border: 1px #3c763d solid;
        background: #3c763d;
        color: #d6e9c6;
    }

    .button-box.refuse-box{
        border: 1px #ebccd1 solid;
        background: #ebccd1;
        color: #a94442;
    }

    .button-box.refuse-box:hover{
        border: 1px #a94442 solid;
        background: #a94442;
        color: #ebccd1;
    }
</style>